/*
================================================================
	Copyright © 2024, Cheers Interactive Pvt Ltd.  All rights reserved.
	  File Description : Access Earthdoc Routes 
----------------------------------------------------------------
	Creation Details
	Date Created				: 20/May/2025
	Author						: Satya Prakash Mall
================================================================
*/
import React, { Suspense } from "react";
import { Switch } from "react-router-dom";
import AuthLayout from "../app/layout/authLayout";
import AccessEarthdocListing from "../app/views/accessEarthdoc";

const PROPERTIES = ["Properties:VIEW", "Properties:FULL"];

const AccessEarthdocRoutes = () => (
  <Suspense
    fallback={
      <div className="text-center">
        <h3>Loading...</h3>
      </div>
    }
  >
    <Switch>
      <AuthLayout
        exact
        path="/access-earthdoc"
        component={AccessEarthdocListing}
        pageHeading="GenNx CMS - Access Earthdoc"
        accessRights={{
          moduleName: "Access Earthdoc",
          parentModuleName: "",
          moduleAttribute: [...PROPERTIES],
          interfaceName: "Listing",
        }}
      />
    </Switch>
  </Suspense>
);

export default AccessEarthdocRoutes;
